/** The part of an activated route snapshot the pattern is read from. */
export interface RouteNode {
  routeConfig: { path?: string } | null;
  outlet?: string;
  firstChild: RouteNode | null;
  children?: RouteNode[];
}

/** The configured path of a route and everything below it in its own outlet, e.g. ['patient', ':id']. */
function pathsOf(node: RouteNode | null): string[] {
  const parts: string[] = [];
  for (let at = node; at; at = at.firstChild) {
    const path = at.routeConfig?.path;
    if (path === '**') return ['not-found'];
    if (path) parts.push(path);
  }
  return parts;
}

/**
 * The current page as its configured route, e.g. '/patient/:id/invoices': never the address with ids in it. What a
 * named outlet shows is added in brackets, e.g. '/patients/list (patient:add)'.
 */
export function routePatternOf(root: RouteNode): string {
  const parts: string[] = [];
  const outlets: string[] = [];
  for (let node: RouteNode | null = root; node; node = node.firstChild) {
    const path = node.routeConfig?.path;
    if (path === '**') return '/not-found';
    if (path) parts.push(path);
    for (const child of node.children ?? []) {
      if (child.outlet && child.outlet !== 'primary') outlets.push(`(${child.outlet}:${pathsOf(child).join('/')})`);
    }
  }
  return [`/${parts.join('/')}`, ...outlets].join(' ');
}
